import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Location } from '@angular/common';
import { SideBarComponent } from '../../../components/side-bar/side-bar.component';
import { FooterComponent } from "../../../components/footer/footer.component";
import { HeaderComponent } from "../../../components/header/header.component";

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [CommonModule, SideBarComponent, FooterComponent, HeaderComponent],
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent {

  constructor(
    private location: Location,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  /**
   * Logged-in users must see the dashboard sidebar (their account menu),
   * not the guest "Create Account / Sign In" landing sidebar.
   */
  get sidebarMode(): 'dashboard' | 'landing' {
    return isPlatformBrowser(this.platformId) && !!localStorage.getItem('token')
      ? 'dashboard'
      : 'landing';
  }

  scrollToSection(n: number): void {
    if (!isPlatformBrowser(this.platformId)) return;
    const el = document.getElementById('section-' + n);
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  CloseModal() {
    this.location.back();
  }

}
